export default __webpack_public_path__ + "static/media/product_bg.9087307a.png";